import { mapArrayElement } from "@draftkings/sportsbook-common-utils";
export function mapSportsbookContentCardAdd(data) {
    return {
        id: data[1],
        title: data[2],
        cardLabel: data[3],
        sortOrder: data[4],
        selections: mapContentCardSelections(data[5]),
        betCount: data[6],
        displayOdds: mapDisplayOdds(data[7]),
        isSuspended: data[8],
    };
}
export function mapSportsbookContentCardUpdate(data) {
    return {
        id: data[1],
        betCount: data[2],
        selections: mapContentCardSelections(data[3]),
        displayOdds: mapDisplayOdds(data[4]),
        isSuspended: data[5],
    };
}
function mapDisplayOdds(data) {
    return {
        american: data[1],
        decimal: data[2],
        fractional: data[3],
    };
}
function mapContentCardSelections(selections) {
    return selections.map((data) => ({
        selectionId: data[1],
        outcomeType: data[2],
        selectionLabel: data[3],
        sportId: data[4],
        leagueId: data[5],
        eventId: data[6],
        marketId: data[7],
        points: data[8],
        isSameGameParlay: data[9],
        participants: mapArrayElement(data[11], mapParticipantSlims),
    }));
}
function mapParticipantSlims(participantsSlims) {
    return participantsSlims.map(data => ({
        id: data[1],
        type: data[2],
        teamId: data[3],
    }));
}
//# sourceMappingURL=mapSportsbookContentCard.js.map